module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }